import React, { useRef, useState } from 'react';
import { Tooltip, Overlay } from 'react-bootstrap';
import { ChevronRight } from 'react-feather';

type LabelValue = {
  type: 'LABEL_VALUE';
  label: string;
  value: string;
  tooltip?: string;
};

type IconValue = {
  type: 'ICON_VALUE';
  icon?: boolean;
  text: string;
  children?: React.ReactNode;
};

type SingleValue = {
  type: 'SINGLE_VALUE';
  text: string;
};

type Props = LabelValue | IconValue | SingleValue;

function ReportLine(props: Props) {
  const [show, setShow] = useState(false);
  const pRef = useRef(null);

  const handleMouseEnter = () => {
    setShow(true);
  };

  const handleMouseLeave = () => {
    setShow(false);
  };

  const content = () => {
    if (props.type === 'LABEL_VALUE') {
      const { label, value, tooltip } = props;
      return (
        <>
          <p
            ref={pRef}
            className="font-weight-bold"
            style={{ marginBottom: '0.4rem' }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            {label}
          </p>
          {tooltip && (
            <Overlay target={pRef.current} show={show} placement="right">
              {(props) => <Tooltip {...props}>{tooltip}</Tooltip>}
            </Overlay>
          )}
          <p className="text-uppercase" style={{ marginBottom: '0.4rem' }}>
            {value}
          </p>
        </>
      );
    } else if (props.type === 'ICON_VALUE') {
      const { text, icon, children } = props;
      return (
        <div>
          {icon && <ChevronRight className="fs-5 text-dark icon-gap-right" />}{' '}
          <span className="fw-bold fs-5 text-dark">{text}</span>
          {children && <p className="ms-4 mt-1 mb-0">{children}</p>}
        </div>
      );
    }
  };

  return <div className="d-flex justify-content-between my-1">{content()}</div>;
}

export default ReportLine;
